import { render } from "./slideshow.vue?vue&type=template&id=4d481d16&scoped=true&ts=true"
import script from "./slideshow.vue?vue&type=script&lang=ts"
export * from "./slideshow.vue?vue&type=script&lang=ts"

import "./slideshow.vue?vue&type=style&index=0&id=4d481d16&scoped=true&lang=css"

import exportComponent from "/Volumes/jstChillin/Dropbox/pdc2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d481d16"]])

export default __exports__